export const ProsvetaPublishers = [3, 4, 5, 32];